"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseAuthManager = /** @class */ (function () {
    function BaseAuthManager() {
        var token = this.getStorage(BaseAuthManager.TOKEN_KEY);
        if (token) {
            this.setToken(token);
        }
    }
    /**
     * 设定鉴权token
     *
     * @param {string} [token]
     * @returns {boolean}
     * @memberof AuthClient
     */
    BaseAuthManager.prototype.setToken = function (token) {
        this._token = token;
        this.setStorage(BaseAuthManager.TOKEN_KEY, token);
        return this._token;
    };
    /** set storage adapter */
    BaseAuthManager.prototype.setStorage = function (key, value) {
        console.log("set cache, key: " + key + ", value: " + value);
    };
    /** get storage adapter */
    BaseAuthManager.prototype.getStorage = function (key) {
        console.log("get cache, key: " + key);
        return;
    };
    /** clear storage adapter */
    BaseAuthManager.prototype.clearStorage = function (key) {
        console.log("clear cache, key: " + key);
    };
    /**
     * 获得鉴权token
     *
     * @returns {(string | null)}
     * @memberof AuthClient
     */
    BaseAuthManager.prototype.getToken = function () {
        return this._token;
    };
    /**
     * 是否已经鉴权
     *
     * @returns {boolean}
     */
    BaseAuthManager.prototype.isAuthenticated = function () {
        return !!this._token;
    };
    /**
     * 清除鉴权token
     *
     * @memberof AuthClient
     */
    BaseAuthManager.prototype.invalidate = function () {
        this._token = null;
        this.clearStorage(BaseAuthManager.TOKEN_KEY);
    };
    BaseAuthManager.TOKEN_KEY = 'token';
    return BaseAuthManager;
}());
exports.BaseAuthManager = BaseAuthManager;
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/services/auth.js
// module id = 1041
// module chunks = 0